import { createSlice } from '@reduxjs/toolkit';
import { User } from 'pages/login';

interface InternalUser extends Omit<Partial<User>, 'user_id' | 'name'> {
  userId: string | null;
  username: string | null;
}

// interface User {
//   userId: string | null;
//   username: string | null;
//   // user_id: string;
//   user_role?: string;
//   // name: string;
//   email?: string;
//   wwid?: string;
//   company_domain?: string;
//   first_name?: string;
//   last_name?: string;
// }

const initialState: InternalUser = JSON.parse(
  localStorage.getItem('mic-user')!
) || {
  userId: null,
  username: null,
};
// {
//   userId: JSON.parse(localStorage.getItem('mitac-user')!)?.userId || null,
//   username: JSON.parse(localStorage.getItem('mitac-user')!)?.username || null,
// };

const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (
      state,
      action: { type: string; payload: InternalUser | null }
    ) => {
      return action.payload || { userId: null, username: null };
    },
  },
});

export const { setUser } = authSlice.actions;

export default authSlice.reducer;
